import React from 'react';
import { LoadingContainer } from './LoadingStyles';
import Icon from '../../assets/icons/efrs_loading.svg';

const LoadingPage = () => {
  return (
    <LoadingContainer>
      <img src={Icon} alt="Loading" />
    </LoadingContainer>
  );
};

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingPage.js